import React from 'react';
import Imagen from '../img/photo_coach.jpeg'

export default function QuienSoy() {
    return (
        <div className='container mx-auto'>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-2 py-10 m-5 '>
                <div className='flex items-center justify-center'>
                    <img src={Imagen} className='w-3/4'/>
                </div>
                <div className='flex items-center justify-center'>
                    <p className='text-2xl p-2 font-times'>
                         Me llamo nelson Fernando Mendoza cuento con más de 20 años de experiencia como coach, especializado en gestión del tiempo, Programación Neurolingüística (PNL), desarrollo personal y mentoría. Mi formación en instituciones de prestigio como Case Western Reserve University, Axon Trading y el Politécnico Superior de Medellín me ha permitido ofrecer un enfoque integral. Me inspiro en grandes referentes como Jim Rohn, John Maxwell y Napoleon Hill, cuyas enseñanzas aplico para fortalecer el liderazgo y acompañar procesos de transformación personal y profesional.<br/>
                        Creo firmemente en el poder de elevar nuestros estándares a través del conocimiento, la espiritualidad y el trabajo en equipo. Por eso, estudio y comparto la sabiduría de mentores como Tony Robbins, Conny Méndez y Mario Alonso Puig. Mi propósito es guiar a personas y equipos hacia sus objetivos, con un acompañamiento estratégico que genere resultados reales y duraderos, impulsando una vida en armonía con valores como la paz, el amor y la abundancia.
                    </p>
                </div>
            </div>
        </div>
    )

}